import * as React from "react";
import { BaseSyntheticEvent, ChangeEvent, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  Radio,
  RadioGroup,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import {
  useForm,
  Controller,
  FieldValues,
  set,
  FormSubmitHandler,
  SubmitHandler,
} from "react-hook-form";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { TaskmgmtServiceURL } from "../../../config/config";
import { ServiceName } from "../../../constants";
import { RegionOptions } from "../../../constants";
import { useAppSelector } from "../../../redux/hooks";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import "./UserRoleMapDashboard.css";
import { wait } from "@testing-library/user-event/dist/utils";
import { ToastMessage } from "../../util/ToastMessage";
import { AlertDialog } from "../../util/Dialog";
import { UserRole } from "./UserRoleMapFormNew";
import { UserRoleMap } from "components/util/All_interfaces";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export class Roles {
  label!: string;
  value!: string;
  region!: string[];
}
class Region {
  label!: string;
  value!: string;
}
class User {
  label!: string;
  value!: {
    id: string;
    firstName: string;
    lastName: string;
    firm: string;
    email: string;
    status: string;
    createdBy: string;
    created: string;
    lastModifiedBy: string;
    lastModified: string;
  };
}

class Funds {
  label!: string;
  value!: {
    id: string;
    fundID: string;
    fundName: string;
    region: string;
    createdBy: string;
    created: string;
    lastModified: string;
    lasModifiedBy: string;
  };
  region: string[] = [];
}

// class Fund {
//   fundId!:string;
//   fundName!:string;
// }

export const UserRoleMapEditDisplayForm = () => {
  const navigate = useNavigate();
  const params = useParams();
  const page = params.page;
  const userRoleMapId = params.userRoleId;
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const anyFund: Funds[] = [
    {
      label: "Any",
      value: {
        id: "",
        fundID: "Any",
        fundName: "Any",
        region: "",
        createdBy: "",
        created: "",
        lastModified: "",
        lasModifiedBy: "",
      },
      region: [],
    },
  ];

  const anyFundArray:any[] = [{
    key: 2000,
    label: "Any",
    value: {
        id: 2000,
        fundID: "Any",
        fundName: "Any",
        region: "US",
        createdBy: "",
        created: "",
        lastModifiedBy: "",
        lastModified: ""
    },
    region: [
        "US","APAC","APAC"
    ]
}];
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const [objUser, setObjUser] = useState<UserRoleMap>(new UserRoleMap());
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const investmentType = ["Equity", "Debt Asset", "Debt Liability", "Mortgage"];
  const [loading, setLoading] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [showErrorBorder, setShowErrorBorder] = useState<
    { controlName: string; isEmpty: boolean }[]
  >([
    { controlName: "Roles", isEmpty: false },
    { controlName: "Region", isEmpty: false },
    { controlName: "User", isEmpty: false },
    { controlName: "Funds", isEmpty: false },
    { controlName: "InvestmentType", isEmpty: false },
  ]);
  //Roles
  const [filteredRoles, setFilteredRoles] = useState<any[]>([]);
  const [roles, setRoles] = useState<Roles[]>([]);
  const [selectedRole, setSelectedRole] = useState<Roles>(new Roles());

  //regions
  const [regionList, setRegionList] = useState<Region[]>(RegionOptions);
  const [selectedRegion, setSelectedRegion] = useState<any[]>([]);
  const [region, setRegion] = useState<any[]>([]);

  const [fundString, setFundString] = useState<{
    fundId: string;
    fundName: string;
  }>({ fundId: "", fundName: "" });
  const [funds, setFunds] = useState<any[]>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [isShow, setIsShow] = useState<boolean>(false);
  const [userType, setUserType] = useState<string>("Internal");
  const [selectedFunds, setSelectedFunds] = useState<Funds[]>([]);
  const [selectedUser, setSelectedUser] = useState<User>(new User());
  const [filteredFunds, setFilteredFunds] = useState<any[]>([]);
  const [selectedUserEmail, setSelectedUserEmail] = useState<string>("");
  const [status, setStatus] = useState<string>("Active");
  const [selectedInvestmentType, setSelectedInvestmentType] = useState<any[]>(
    []
  );
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const userRoleMap = new UserRole();
  useEffect(() => {
    getAllRecords();
  }, []);

  const getAllRecords = async () => {
    try {
      setLoading(true);

      await getApiCall(
        TaskmgmtServiceURL + "/userrolemaps/getbyid/" + userRoleMapId,
        ServiceName.TASKMANAGEMENTSERVICE
      )
        .then(async (user: any) => {
          var userObject = new UserRoleMap();
          userObject = { ...user.result };
          setObjUser(userObject);
          var RolesArray: any[] = [];
          var FundsArray: any[] = [];
          await getApiCall(
            TaskmgmtServiceURL + "/userrolemaps/UserGetAll",
            ServiceName.TASKMANAGEMENTSERVICE
          )
            .then((users: any) => {
              var userArr: User[] = [];
              userArr = users?.result.map((user: any, index: any) => {
                return {
                  label: user.firstName + " " + user.lastName,
                  value: user,
                };
              });
              const uniqueOptions: User[] = Array.from(
                new Set(userArr.map((a) => a.label))
              ).map((label) => {
                return userArr.filter((a) => a.label === label)[0];
              });
              setUsers(uniqueOptions);
            })
            .catch((e) => console.log(e));

          await getApiCall(
            TaskmgmtServiceURL + "/Funds/getall",
            ServiceName.TASKMANAGEMENTSERVICE
          )
            .then((funds: any) => {
              var fundArr: any[] = [];
              fundArr = funds?.result.map((fund: any) => {
                return {
                  label: fund.fundName,
                  value: fund,
                  region: fund.region != null && fund.region != undefined ? fund.region.split(";") : [],
                };
              });
              const uniqueOptions = Array.from(
                new Set(fundArr.map((a) => a.label))
              ).map((label) => {
                return fundArr.find((a) => a.label === label);
              });

              anyFundArray.forEach((data:any) => {
                uniqueOptions.push(data);
              })
    
              FundsArray = [...uniqueOptions];
              setFunds(uniqueOptions);
            })
            .catch((e) => console.log(e));

          await getApiCall(
            TaskmgmtServiceURL + "/Roles/getall",
            ServiceName.TASKMANAGEMENTSERVICE
          )
            .then((roles: any) => {
              var roleArr: Roles[] = [];
              roleArr = roles?.result.map((item: any) => {
                return {
                  label: item.role,
                  value: item.role,
                  region: item.region != null && item.region != undefined ? item.region.split(";") : [],
                };
              });
              const uniqueOptions: Roles[] = Array.from(
                new Set(roleArr.map((a) => a.label))
              ).map((label) => {
                return roleArr.filter((a) => a.label === label)[0];
              });
              RolesArray = [...uniqueOptions];
              setRoles(uniqueOptions);
            })
            .catch((e) => console.log(e));

          var region: any[] = userObject.region != null && userObject.region != undefined ? userObject.region.split(";") : [];
          var investmentType: string[] = userObject.investmentType != null && userObject.investmentType != undefined ? userObject.investmentType.split(";") : [];
          var regionlst: any[] = RegionOptions.filter((data) =>
            region.includes(data.label)
          );

          var fundIds: string[] = userObject.fundId != null && userObject.fundId != undefined ? userObject.fundId.split(";"):[];
          var fundNames: string[] = userObject.fundName != null && userObject.fundName != undefined ? userObject.fundName.split(";"):[];
          var fundObjArray: Funds[] = fundIds.map((id: any, index) => {
            var fund: Funds = {
              label: fundNames[index],
              value: {
                id: "",
                fundID: id,
                fundName: fundNames[index],
                region: "",
                createdBy: "",
                created: "",
                lastModified: "",
                lasModifiedBy: "",
              },
              region: region,
            };
            return fund;
          });

          setSelectedRegion(regionlst);
          // setShowErrorBorder(
          //   showErrorBorder.map((obj) =>
          //     obj.controlName === "Region"
          //       ? { ...obj, isEmpty: regionlst.length === null }
          //       : { ...obj }
          //   ))
          handelRegionChange(regionlst, FundsArray, RolesArray);
          var Role: any = {
            label: userObject.role,
            value: userObject.role,
            region: regionlst.map((role: any) => role.label),
          };
          handleRoleDetailChange(Role);
          var User: any = {
            label: userObject.userName,
            value: {
              id: null,
              firstName: userObject.firstName,
              lastName: userObject.lastName,
              firm: userObject.firm,
              email: userObject.email,
              status: null,
              createdBy: null,
              created: null,
              lastModifiedBy: null,
              lastModified: null,
            },
          };
          setSelectedRole(Role);
          setSelectedUser(User);
          setSelectedUserEmail(userObject.email);
          setStatus(userObject.status);
          setUserType(userObject.userType);
          setSelectedInvestmentType(investmentType);

          setSelectedFunds(fundObjArray);
          setShowDelete(userObject.showDelete);
        })
        .catch((e) => console.log(e));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleDetailChange = (role: Roles) => {
    setShowErrorBorder(
      showErrorBorder.map((obj) =>
        obj.controlName === "Roles"
          ? { ...obj, isEmpty: role === null }
          : { ...obj }
      )
    );
    console.log(role);
    if (
      role != null &&
      (role.value.toLowerCase() === "admin" ||
        role.value.toLowerCase() === "audit" ||
        role.value.toLowerCase() === "asset management")
    ) {
      setSelectedFunds(anyFund);
      setSelectedInvestmentType(investmentType);
      setIsShow(false);
    } else if (!role) {
      setIsShow(false);
    } else {
      setIsShow(true);
    }
    console.log(filteredRoles);
    setSelectedRole(role);
  };

  //Function to change Roles or Funds according region. argument property represents fund or role
  const fnCheckAllowed = (property: any, regions: any) => {
    var flag = false;

    regions.forEach((region: any) => {
      if (property.region.includes(region.label)) {
        flag = true;
        return true;
      }
    });

    return flag;
  };

  const handelRegionChange = (
    regions: Region[],
    fundArr: any[] = funds,
    roleArr: Roles[] = roles
  ) => {
    setShowErrorBorder(
      showErrorBorder.map((obj) =>
        obj.controlName === "Region"
          ? { ...obj, isEmpty: regions.length === 0 }
          : { ...obj }
      )
    );
    console.log(regions);
    setSelectedRegion(
      regions.sort((a: any, b: any) => a.value.localeCompare(b.value)).reverse()
    );

    //Function to change Funds according region.
    var filteredFunds = fundArr.filter((fund: any) =>
      fnCheckAllowed(fund, regions)
    );
    //Function to change Roles according region.
    var filteredRoles = roleArr.filter((role: any) =>
      fnCheckAllowed(role, regions)
    );

    console.log(regionList);
    console.log(filteredFunds);
    console.log(filteredRoles);

    setFilteredFunds(filteredFunds);
    setFilteredRoles(filteredRoles);
  };

  const handleSelectedUserChange = (user: User) => {
    setShowErrorBorder(
      showErrorBorder.map((obj) =>
        obj.controlName === "User"
          ? { ...obj, isEmpty: user === null }
          : { ...obj }
      )
    );
    console.log(user);
    console.log(users);

    setSelectedUser(user);
    setSelectedUserEmail(user?.value.email);
  };

  const handelFundsChange = (funds: Funds[]) => {
    setShowErrorBorder(
      showErrorBorder.map((obj) =>
        obj.controlName === "Funds"
          ? { ...obj, isEmpty: funds.length === 0 }
          : { ...obj }
      )
    );
    var selectedFund = funds.sort((a, b) => a.label.localeCompare(b.label));
    // var fundIdString = selectedFund.map((a:Funds) => a.values.fundID).join(';');
    // var fundNameString = selectedFund.map((a:Funds) => a.values.fundName).join(';');
    // setFundString({fundId:fundIdString,fundName:fundNameString});
    console.log(selectedFund);
    console.log(filteredFunds);

    setSelectedFunds(selectedFund);
  };

  const handleUserTypeChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setUserType(value);
  };

  const handleStatusChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setStatus(value);
  };

  const handleInvestmentTypeChange = (value: string[]): void => {
    setShowErrorBorder(
      showErrorBorder.map((obj) =>
        obj.controlName === "InvestmentType"
          ? { ...obj, isEmpty: value.length === 0 }
          : { ...obj }
      )
    );
    console.log(investmentType);

    console.log(value);
    setSelectedInvestmentType(value.sort());
  };

  const UpdateUserRoleMap = () => {
    // if(){}
    console.log(showErrorBorder);
    var s = showErrorBorder.filter((e) => e.isEmpty === true);
    var isRegionValid = selectedRegion.length !== 0;
    var isRoleValid = selectedRole != null && selectedRole != undefined;
    var isUserValid = selectedUser != null && selectedUser != undefined;
    var isFundValid =  funds.length !== 0;
    var isInvestmentTYpeValid = selectedInvestmentType.length !== 0;

    var validator = isRegionValid && isRoleValid && isUserValid && isFundValid && isInvestmentTYpeValid;
    if (s.length === 0 && validator) {
      objUser.id = objUser.id;
      objUser.fundId = selectedFunds.map((fund) => fund.value.fundID).join(";");
      objUser.fundName = selectedFunds
        .map((fund) => fund.value.fundName)
        .join(";");
      objUser.investmentType = selectedInvestmentType
        .map((type: any) => type)
        .join(";");
      objUser.region = selectedRegion.map((region) => region.label).join(";");
      objUser.oldRole = objUser.role;
      objUser.role = selectedRole.label;
      objUser.userName = selectedUser.label;
      objUser.firstName = selectedUser.value.firstName;
      objUser.lastName = selectedUser.value.lastName;
      objUser.userID = selectedUserEmail;
      objUser.email = selectedUserEmail;
      objUser.userType = userType;
      objUser.lastModifiedBy =
        currentUserData.email == undefined ? "" : currentUserData.email;
      objUser.firm = userType == "Internal" ? "TIAA" : selectedUser.value.firm;
      objUser.status = status;
      try {
        setLoading(true);
        postApiCall(
          TaskmgmtServiceURL + "/userrolemaps/update",
          objUser,
          ServiceName.TASKMANAGEMENTSERVICE
        )
          .then((res: any) => {
            setIsSuccess({
              isSuccess: true,
              message: "User Role map is updated",
            });
            wait(3000).then(() => {
              navigate("/userrolemap/list");
            });
          })
          .catch((error: any) => {
            console.log(error);
            setIsError({
              isError: true,
              message: error.response.data.responseException.exceptionMessage,
            });
          });
      } catch (error) {
        console.log(error);
      } finally {
        wait(1000).then(() => {
          setLoading(false);
        });
        setIsError({ isError: false, message: "" });
        setIsSuccess({ isSuccess: false, message: "" });
      }
    } else {
      setIsError({isError:true,message:"Please clear validation errors."});
      wait(3000).then(() =>
        setIsError({isError:false,message:""})
      )
      console.log("Clear erors");
    }
  };

  const DeleteUserRoleMap = () => {
    var ids: string[] = [];
    ids.push(objUser.id.toString());
    try {
      setOpenDialog(false);
      setLoading(true);
      postApiCall(
        TaskmgmtServiceURL + "/userrolemaps/delete",
        [objUser.id.toString()],
        ServiceName.TASKMANAGEMENTSERVICE
      )
        .then((res: any) => {
          setIsSuccess({
            isSuccess: true,
            message: "User Role Map is Deleted",
          });
          wait(3000).then(() => {
            navigate("/userrolemap/list");
          });
        })
        .catch((error: any) => {
          console.log(error);
          setIsError({
            isError: true,
            message: error.response.data.responseException.exceptionMessage,
          });
        });
    } catch (error) {
      console.log(error);
    } finally {
      wait(1000).then(() => {
        setLoading(false);
      });
    }
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const openConfirmBox = () => {
    setOpenDialog(true);
  };

  return (
    <div className="form-wrap">
      {loading && (
        <div className="overlaySpinner">
          <CircularProgress />
        </div>
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
      {
        <AlertDialog
          isOpen={openDialog}
          handleClose={closeDialog}
          onConfirm={DeleteUserRoleMap}
          title={"Attention"}
          message={"Are you sure you want to delete this record?"}
        />
      }
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      <Box sx={{ width: "100%", typography: "body1" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <Controller
              name="Region"
              control={control}
              rules={{ required: "Region is required." }}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  {...field}
                  multiple
                  aria-label="Region_test"
                  id="checkboxes-tags-demo"
                  options={regionList}
                  value={selectedRegion}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label &&
                    option.value === value.value
                  }
                  readOnly={page === "view"}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.label}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  )}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handelRegionChange(value);
                  }}
                  // style={{ width: 500 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region"
                      size="small"
                      error={selectedRegion.length === 0}
                      placeholder={page === "view" ? "" : "Selece region"}
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="roles"
              control={control}
              rules={{ required: "roles is required." }}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  id="userRoleList"
                  disabled={selectedRegion.length == 0}
                  options={filteredRoles}
                  value={selectedRole}
                  readOnly={page === "view"}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleRoleDetailChange(value);
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label
                  }
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => (
                    <Tooltip
                      title={
                        selectedRegion.length === 0
                          ? "First select Region"
                          : ""
                      }
                      placement="top-start"
                      arrow
                    >
                      <TextField
                        {...params}
                        label="Role"
                        size="small"
                        error={selectedRole === null}
                        placeholder="Select Role"
                        required
                        InputLabelProps={{
                          sx: {
                            '& .MuiInputLabel-asterisk': {
                              color: 'red',
                            },
                          },
                        }}
                      />
                    </Tooltip>
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="user"
              control={control}
              rules={{ required: "User is required." }}
              render={({ field, fieldState: { error } }) => (
                <Autocomplete
                  id="user"
                  options={users}
                  value={selectedUser}
                  readOnly={page === "view"}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label
                  }
                  getOptionLabel={(option) => option.label}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleSelectedUserChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="User"
                      size="small"
                      error={selectedUser === null}
                      placeholder="Select Role"
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                    />
                  )}
                  disableClearable
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <TextField
              label="Email"
              size="small"
              className="Autopopulatefield"
              value={selectedUserEmail}
              InputProps={{
                readOnly: true,
              }}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <FormControl
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label">
                User Type
              </FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-readonly={page === "view"}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={userType}
                onChange={handleUserTypeChange}
              >
                <FormControlLabel
                  disabled={page === "view"}
                  value="Internal"
                  control={<Radio />}
                  label="Internal"
                />
                <FormControlLabel
                  disabled={page === "view"}
                  value="External"
                  control={<Radio />}
                  label="External"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControl
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label">Status</FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={status?.toLowerCase() === "active" ? "Active" : "InActive"}
                onChange={handleStatusChange}
              >
                <FormControlLabel
                  value="Active"
                  disabled={page === "view"}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="InActive"
                  disabled={page === "view"}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {isShow && (
            <Grid item xs={6} sm={6}>
              <Controller
                name="Fund"
                control={control}
                rules={{ required: "Fund is required." }}
                render={({ field, fieldState: { error } }) => (
                  <Autocomplete
                    multiple
                    disabled={selectedRegion.length === 0}
                    readOnly={page === "view"}
                    id="checkboxes-tags-demo"
                    options={filteredFunds}
                    value={selectedFunds}
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) =>
                      option.label === value.label
                    }
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, value) => {
                      field.onChange(value);
                      handelFundsChange(value);
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <Tooltip
                        title={
                          selectedRegion.length === 0
                            ? "To edit funds first select Region"
                            : ""
                        }
                        placement="top-start"
                        arrow
                      >
                        <TextField
                          label="Fund(s)"
                          {...params}
                          size="small"
                          error={selectedFunds.length === 0}
                          required
                          InputLabelProps={{
                            sx: {
                              '& .MuiInputLabel-asterisk': {
                                color: 'red',
                              },
                            },
                          }}
                          placeholder="Fund(s)"
                        />
                      </Tooltip>
                    )}
                  />
                )}
              />
            </Grid>
          )}
          {isShow && (
            <Grid item xs={6} sm={6}>
              <Controller
                name="Investment Type"
                control={control}
                rules={{ required: "Investment Type is required." }}
                render={({ field, fieldState: { error } }) => (
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={investmentType}
                    value={selectedInvestmentType}
                    readOnly={page === "view"}
                    disabled={selectedRegion.length === 0}
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) => option === value}
                    getOptionLabel={(option) => option}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option}
                      </li>
                    )}
                    onChange={(event, value) => {
                      field.onChange(value);
                      handleInvestmentTypeChange(value);
                    }}
                    // style={{ width: 500 }}
                    renderInput={(params) => (
                      <Tooltip
                        title={
                          selectedRegion.length === 0
                            ? "To edit investment types first select Region"
                            : ""
                        }
                        placement="top-start"
                        arrow
                      >
                        <TextField
                          label="Investment Types(s)"
                          {...params}
                          size="small"
                          error={selectedInvestmentType.length === 0}
                          placeholder="Investment Type(s)"
                          required
                          InputLabelProps={{
                            sx: {
                              '& .MuiInputLabel-asterisk': {
                                color: 'red',
                              },
                            },
                          }}

                        />
                      </Tooltip>
                    )}
                  />
                )}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12}>
            {page != "view" && (
              <Button sx={{ textTransform: "none" }}
                disabled={isError.isError || isSuccess.isSuccess}
                variant="contained"
                size="medium"
                color="success"
                type="submit"
                onClick={UpdateUserRoleMap}
              >
                Submit
              </Button>
            )}
            {page === "view" && (
              <Button sx={{ textTransform: "none" }}
                variant="contained"
                size="medium"
                color="success"
                onClick={() => navigate("/userrolemap/edit/" + objUser.id)}
              >
                Edit
              </Button>
            )}
            <Button
              variant="outlined"
              size="medium"
              color="error"
              sx={{ ml: 2 }}
              onClick={() => navigate("/userrolemap/list")}
            >Cancel
            </Button>
            {showDelete && (
              <Button
                disabled={isError.isError || isSuccess.isSuccess}
                variant="contained"
                size="medium"
                sx={{ textTransform: "none", ml: 2 }}
                color="warning"
                onClick={openConfirmBox}
              >
                Delete & Archive
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
